/* BEZPIECZNIK WARIANTU - ostatnia linia obrony przed „wybrałam M, przyszło XS".
 *
 * Po co: selektor rozmiaru w Horizonie aktualizuje adres (?variant=) i stan swojego
 * komponentu. Gdy ta aktualizacja się zawiesi (wolna sieć, przerwane żądanie sekcji),
 * przyciski dalej pokazują M, ale do koszyka leci wariant początkowy - pierwszy
 * rozmiar z listy, czyli XS.
 *
 * Gdzie wpinamy: w SAMO ŻĄDANIE do /cart/add. Sprawdzone na żywym sklepie 03.08:
 * poprawianie ukrytego pola `id` w formularzu NIC NIE DAJE, bo motyw nie czyta
 * formularza przy wysyłce - buduje treść żądania z własnego stanu. Dopiero podmiana
 * pola `id` w wychodzącym żądaniu trafia w rzeczywistą przyczynę.
 *
 * Źródło prawdy: `data-variant-id` z ZAZNACZONEGO przycisku rozmiaru. To dokładnie
 * to, co widzi klientka - a jej wybór jest ważniejszy niż stan komponentu.
 *
 * Zasada nadrzędna: skrypt NIE MOŻE zablokować zakupu. Każda ścieżka kończy się
 * cicho, gdy czegoś nie znajdzie albo cokolwiek rzuci - lepiej brak zabezpieczenia
 * niż koszyk, którego nie da się użyć.
 */
(function () {
  "use strict";

  // Zaznaczony wariant wg tego, co widać na ekranie. null = nie umiemy ustalić
  // (np. produkt bez wariantów albo inny szablon) - wtedy NIC nie robimy.
  function zaznaczonyWariant() {
    try {
      const radia = document.querySelectorAll('input[type="radio"][data-variant-id]');
      let znaleziony = null;
      for (const r of radia) {
        if (!r.checked || !r.dataset.variantId) continue;
        // Dwa różne zaznaczone warianty = strona z kilkoma produktami (np. „stwórz set").
        // Nie zgadujemy, który jest ten właściwy - odpuszczamy.
        if (znaleziony && znaleziony !== String(r.dataset.variantId)) return null;
        znaleziony = String(r.dataset.variantId);
      }
      return znaleziony;
    } catch {
      return null;
    }
  }

  function popraw(cialo) {
    try {
      if (!cialo || typeof cialo.get !== "function") return;
      const wybrany = zaznaczonyWariant();
      const wZadaniu = cialo.get("id");
      if (!wybrany || !wZadaniu || String(wZadaniu) === wybrany) return;
      // Zostawiamy ślad w konsoli - jeśli to się dzieje często, chcemy o tym wiedzieć.
      console.warn("[gg-variant-guard] żądanie miało wariant", String(wZadaniu),
        "a klientka ma zaznaczony", wybrany, "- poprawiam");
      cialo.set("id", wybrany);
    } catch { /* nigdy nie przerywamy zakupu */ }
  }

  const oryginalny = window.fetch;
  if (typeof oryginalny !== "function") return;

  window.fetch = function (zasob, opcje) {
    try {
      const adres = String((zasob && zasob.url) || zasob || "");
      if (/\/cart\/add(\.js)?(\?|$)/.test(adres) && opcje
          && (opcje.body instanceof FormData || opcje.body instanceof URLSearchParams)) {
        popraw(opcje.body);
      }
    } catch { /* jw. */ }
    return oryginalny.apply(this, arguments);
  };

  // NATYWNY SUBMIT - droga, którą 06.08 znowu wjechał XS zamiast L. Gdy komponent
  // motywu wisi po zmianie rozmiaru, kliknięcie „Dodaj do koszyka" nie jest
  // przejmowane przez JS i przeglądarka wysyła formularz sama: POST /cart/add
  // z UKRYTEGO pola `id`, które w czasie zawieszenia trzyma jeszcze stary wariant
  // (sprawdzone na żywo: radio L, pole id=XS przez kilka sekund). Fetch-owy
  // strażnik tego nie widzi, bo żadnego fetcha nie ma - stąd nasłuch na submit.
  // Radia czytamy z TEJ SAMEJ sekcji co formularz (nie z całej strony), żeby
  // pasek polecanych czy szybkie dodanie z innej sekcji nie podmieniły wyboru.
  document.addEventListener("submit", (e) => {
    try {
      const form = e.target;
      if (!form || !/\/cart\/add/.test(form.getAttribute("action") || "")) return;
      const pole = form.querySelector('input[name="id"]');
      if (!pole) return;
      const zakres = form.closest(".shopify-section") || document;
      let wybrany = null;
      for (const r of zakres.querySelectorAll('input[type="radio"][data-variant-id]')) {
        if (!r.checked || !r.dataset.variantId) continue;
        if (wybrany && wybrany !== String(r.dataset.variantId)) return; // niejednoznaczne - odpuszczamy
        wybrany = String(r.dataset.variantId);
      }
      if (!wybrany || String(pole.value) === wybrany) return;
      console.warn("[gg-variant-guard] natywny submit miał wariant", String(pole.value),
        "a klientka ma zaznaczony", wybrany, "- poprawiam");
      pole.value = wybrany;
    } catch { /* nigdy nie przerywamy zakupu */ }
  }, true);

  // Pasek przyklejony u dołu trzyma własną kopię numeru wariantu - synchronizujemy
  // ją przy każdej zmianie rozmiaru, żeby nie był drugim źródłem tego samego błędu.
  document.addEventListener("change", (e) => {
    try {
      const r = e.target;
      if (!r || r.type !== "radio" || !r.dataset || !r.dataset.variantId) return;
      const pasek = document.querySelector("sticky-add-to-cart[data-current-variant-id]");
      if (pasek) pasek.setAttribute("data-current-variant-id", String(r.dataset.variantId));
    } catch { /* jw. */ }
  }, true);
})();
